import React from 'react';

import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';

import * as ActionsDialog from 'app/store/actions';

const ErrorDialog = props => {
	const dispatch = useDispatch();

	const handleClose = () => {
		if (props.clearError) {
			props.clearError();
		}
		dispatch(ActionsDialog.closeDialog());
	};

	const title = props.title || 'ERROR!!!';

	return (
		<React.Fragment>
			<DialogTitle>
				<Typography className={`font-bold ${props.title ? '' : 'text-red'}`}>{title}</Typography>
			</DialogTitle>
			<DialogContent id="err-msg">{props.message}</DialogContent>
			<DialogActions>
				<Button id="err-acknowlege" onClick={() => handleClose()} variant="outlined">
					Close
				</Button>
			</DialogActions>
		</React.Fragment>
	);
};

export default ErrorDialog;
